import { defineNuxtRouteMiddleware, useRouter } from "#app";

export default defineNuxtRouteMiddleware((to, from) => {
  const router = useRouter();
  // 등록된 모든 라우트 가져오기
  const allRoutes = router.getRoutes().map((route: any) => route.path);
  // console.log('allRoutes ::::::::::: ', allRoutes)
  // 현재 경로가 등록된 라우트에 포함되어 있는지 확인
  const isPathValid = (path: string) => allRoutes.includes(path);

  if (!isPathValid(to.path)) {
    return navigateTo("/404"); // 서버에서 404로 리다이렉트
  }
});